import { render, staticRenderFns } from "./ProductActions.vue?vue&type=template&id=4be52763&"
import script from "./ProductActions.vue?vue&type=script&lang=js&"
export * from "./ProductActions.vue?vue&type=script&lang=js&"
import style0 from "./ProductActions.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {QuantitySelector: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/QuantitySelector.vue').default,Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
